import { render, staticRenderFns } from "./FletrixChipAutocomplete.vue?vue&type=template&id=2baa261b&"
import script from "./FletrixChipAutocomplete.vue?vue&type=script&lang=js&"
export * from "./FletrixChipAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./FletrixChipAutocomplete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
